import {debounce, uid} from 'quasar-framework'

export default {
    data() {
        return {
            // Store references to table elements
            id: `infinite-scroll-${uid()}`,
            sheet: null,
            thead: null,
            tbody: null,
            container: null,
            prevScrollPos: 0, // This with store the last iterated scroll position
            thWidths: [] // This array will contain all the dimensions from ths
        }
    },
    mounted() {
        // Get the refence to the table container element in DOM
        this.container = this.$el.getElementsByClassName('q-table-middle')[0]

        // Add a class name with the id, so it can react to our css
        this.container.className += ' ' + this.id

        // Create a html element for the stylesheet that contains our widths, etc
        this.sheet = document.createElement('style')
        this.sheet.setAttribute('title', this.id)

        // Append it to the document
        document.body.appendChild(this.sheet)

        // Store the references to the table head and body
        this.thead = this.container.querySelector('thead')
        this.tbody = this.container.querySelector('tbody')

        if (this.infiniteScroll) {
            // Add listeners
            this.addListeners()

            // Add classes to the stylesheet
            this.$nextTick(() => this.relayout())
        }
    },
    computed: {
        visibleData() {
            return this.data
        }
    },
    methods: {
        // Clear the styles
        clearStyles() {
            this.sheet.innerHTML = ''
        },

        // Add  styles to fix the header and rows
        relayout() {
            // Clear before calculate
            this.clearStyles()

            let ths = [].slice.call(this.thead.querySelectorAll('th')) || []

            // Store width of each th getBoundingClientRect()'s including paddings and borders
            let totalWidth = 0
            let thHeight = 0
            if (ths.length > 0)
                thHeight = document.defaultView.getComputedStyle(ths[0], '').height
            this.thWidths = ths.map(th => {
                totalWidth += th.getBoundingClientRect().width
                return document.defaultView.getComputedStyle(th, '').width
            })

            // Style container, position thead and tbody and trs
            this.sheet.innerHTML = `
                    .${this.id} thead { 
                        display:block; 
                        width: ${totalWidth}px;
                        position: relative;
                    }
                    .${this.id} tbody {
                        display: block; 
                        width: ${totalWidth}px; 
                        height: ${this.height}px; 
                        overflow: auto;
                    }
                    .${this.id} tr {
                        display: block;
                    }
                `

            // Set widths of the ths ans tds elements
            ths.forEach((th, i) => this.sheet.innerHTML += `
                    .${this.id} tr th:nth-child(${i + 1}) {
                        width: ${this.thWidths[i]}; 
                        height: ${thHeight}; 
                    }
                    .${this.id} tr td:nth-child(${i + 1}):not(.ignore-infinite) {
                        width: ${this.thWidths[i]}; 
                    }
                `)

            this.sheet.innerHTML += `
                    .${this.id} tr.q-table-progress {
                        width: ${this.container.getBoundingClientRect().width}px !important;
                        position:relative;
                    }
                    .${this.id} tr.q-table-progress td {
                        width: ${this.container.getBoundingClientRect().width}px !important;
                    }
                `
        },

        // Update table cell dimensions on resize
        onResize: debounce(() => this.relayout(), 500),

        onScroll() {
            // Make the thead and .q-table-progress x axis follow the tbdoy position
            let sheet = getStyleSheet(this.id)
            if (sheet) {
                let progressRule = getCssRuleIndexBy(`.${this.id} tr.q-table-progress`, sheet)
                if (progressRule)
                    sheet.cssRules[progressRule].style.left = this.container.scrollLeft + 'px'
            }

            // Get the current scroll position
            let scrollPos = this.tbody.scrollTop

            // Exit if the scroll position didn't changed or the datable is already loading or destroyed
            if (scrollPos == this.prevScrollPos || !this.$refs.QTable || this.$refs.QTable.loading) return

            // Store the scroll posistion for the next iteration
            this.prevScrollPos = scrollPos

            // Check if scroll bar position is Npx above the max and if
            // we still have what to load, if yes, initiate an update
            if (this.tbody.scrollHeight - (scrollPos + this.tbody.offsetHeight) < this.distance &&
                this.pagination.page < this.maxPage)
                this.$refs.QTable.nextPage()
        },

        // Add listeners
        addListeners() {
            // Add a scroll listener on container
            this.tbody.addEventListener('scroll', this.onScroll, false)
            this.tbody.addEventListener('touchmove', this.onScroll, false)

            // Update table cell dimensions on resize
            window.addEventListener('resize', this.onResize, false)
        },

        // Remove listeners
        removeListeners() {
            this.container.removeEventListener('scroll', this.onScroll)
            this.container.removeEventListener('touchmove', this.onScroll)
            window.removeEventListener('resize', this.onResize)
        }
    },
    watch: {
        visibleColumns: 'relayout',
        infiniteScroll() {
            if (this.infiniteScroll) {
                this.addListeners()

                this.$nextTick(() => this.relayout())

                let pagination = deepCopy(this.pagination)

                if (pagination.page > 1 || pagination.page == 0)
                    pagination.page = 1

                pagination.rowsPerPage = 100

                if (pagination.page != this.pagination.page || pagination.rowsPerPage != this.pagination.rowsPerPage)
                    this.$emit('request', {pagination, ...this.filter})
            } else {
                this.clearStyles()
                this.removeListeners()
                this.pagination.rowsPerPage = 10
                if (this.pagination.rowsPerPage < this.data.length)
                    this.$emit('request', {...this.pagination, ...this.filter})
            }
        }
    },
    beforeDestroy() {
        // Remove the style sheet from the DOM and the event listeners from the window and container
        document.body.removeChild(this.sheet)

        // If there is a fixed table (infinite scroll) we tell it
        // to destroy and we remove scrollEl event listeners
        if (this.infiniteScroll) {
            this.removeListeners()
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/fixedTable.js